var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSquadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.0428 16.5C19.7297 16.5 20.276 16.0678 20.7666 15.4633C21.7707 14.2261 20.122 13.2374 19.4933 12.7532C18.854 12.261 18.1403 11.9821 17.4167 11.9167M16.5 10.0833C17.7656 10.0833 18.7917 9.05732 18.7917 7.79167C18.7917 6.52602 17.7656 5.5 16.5 5.5",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.95715 16.5C2.27029 16.5 1.72397 16.0678 1.23344 15.4633C0.229267 14.2261 1.87797 13.2374 2.50678 12.7532C3.14599 12.261 3.85972 11.9821 4.58335 11.9167M5.04169 10.0833C3.77603 10.0833 2.75002 9.05732 2.75002 7.79167C2.75002 6.52602 3.77603 5.5 5.04169 5.5",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.41017 13.8519C6.47355 14.431 4.01776 15.6136 5.51349 17.0934C6.24415 17.8163 7.05791 18.3333 8.08101 18.3333H13.9191C14.9421 18.3333 15.7559 17.8163 16.4865 17.0934C17.9823 15.6136 15.5265 14.431 14.5899 13.8519C12.3934 12.4937 9.60659 12.4937 7.41017 13.8519Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2084 6.87508C14.2084 8.647 12.7719 10.0834 11 10.0834C9.2281 10.0834 7.79169 8.647 7.79169 6.87508C7.79169 5.10316 9.2281 3.66675 11 3.66675C12.7719 3.66675 14.2084 5.10316 14.2084 6.87508Z",
    stroke: "white",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSquadIcon);
export default __webpack_public_path__ + "static/media/squad_icon.99328ea6cc7ac818b9d4663fc64f7e9b.svg";
export { ForwardRef as ReactComponent };